export const brainBoostBackground =
  'https://media.edapp.com/v1637278273/brain-boost/BB-demo-background.png';
